import { useModalContext } from 'src/hooks/useModalContext';
import { ModalWrapper } from 'src/components/ModalWrapper';

const FullScreenImageModal = () => {
  const { modalProps } = useModalContext<{ photo: string }>();

  return (
    <ModalWrapper>
      {!modalProps?.photo.endsWith('pdf') ? (
        <img
          src={modalProps?.photo}
          alt="fullscreen image"
          className="h-[70vh] 1024:h-[60vh] w-auto"
        />
      ) : (
        <iframe src={modalProps?.photo} className="h-[70vh] 1024:h-[60vh] w-auto" />
      )}
    </ModalWrapper>
  );
};

export default FullScreenImageModal;
